import VSparkline from "vuetify/lib/components/VSparkline/VSparkline"
import {debounce} from "lodash/function"
import {isEqual} from "lodash/lang"

export default {
  name: "v-sparkline-horus",
  props: {
    initGradient: {
      type: Number,
      default: 0,
    },
    finalGradient: {
      type: Number,
      default: 1,
    },
  },
  extends: VSparkline,
  methods: {
    genGradient() {
      const gradientDirection = this.gradientDirection
      const gradient = this.gradient.slice() // Pushes empty string to force
      // a fallback to currentColor

      if (!gradient.length) gradient.push("")
      const len = Math.max(gradient.length - 1, 1)
      const stops = gradient.reverse().map((color, index) => this.$createElement("stop", {
        attrs: {
          offset: index / len,
          "stop-color": color || this.color || "currentColor",
        },
      }))
      return this.$createElement("defs", [this.$createElement("linearGradient", {
        attrs: {
          id: this._uid,
          x1: +(gradientDirection === "left"),
          y1: +(gradientDirection === "top"),
          x2: +(gradientDirection === "right"),
          y2: +(gradientDirection === "bottom"),
        },
        ref: "linearGradient",
      }, stops)])
    },
    initGradientDebounce: debounce(function () {
      if (!this.$refs["linearGradient"]) return
      let initGradient = this.initGradient
      if (isEqual(this.initGradient,this.finalGradient))
        initGradient = initGradient - 10e-4
      this.$refs["linearGradient"].setAttribute("x1", initGradient)
    }, 50),
    finalGradientDebounce: debounce(function () {
      if (!this.$refs["linearGradient"]) return
      this.$refs["linearGradient"].setAttribute("x2", this.finalGradient)
    }, 50),
  },
  watch: {
    initGradient: {
      immediate: true,
      handler() {
        this.initGradientDebounce()
      },
    },
    finalGradient: {
      immediate: true,
      handler() {
        this.finalGradientDebounce()
      },
    },
  },
  computed: {
    parsedLabels() {
      const labels = []
      const points = this._values
      const pointsLen = points.length
      const labelsLen = this.labels.length

      labels.push({
        x: points[0].x,
        value: String(this.labels[0]),
      })

      labels.push({
        x: points[parseInt(pointsLen / 2)].x,
        value: String(this.labels[parseInt(labelsLen / 2)]),
      })

      labels.push({
        x: points[pointsLen - 1].x,
        value: String(this.labels[labelsLen - 1]),
      })

      return labels
    },
  },
}
